@if (show) {
  <div class="outside-background"
  (click)="onClose()"></div>
  <core-sidebar class="customizer show"
    @sidebarAnimation>
    <div class="flex column full-height padding">
      <div class="flex align-center flex-0 padding-bottom-small border-bottom">
        <div class="flex-1 align-items-center">
          @if (title) {
            <h3
            class="mb-0 padding-left-small">{{title | translate}}</h3>
          }
        </div>
        <div class="flex-0">
          <button class="btn btn-icon btn-flat-secondary"
            (click)="onClose()">
            <span data-feather="x"></span>
          </button>
        </div>
      </div>
      <div [id]="sidebarContentId"
        class="flex-1 flex column margin-top margin-bottom overflow mini">
        <ng-content></ng-content>
      </div>
      <!-- parità legacy: 'first' stava sull'*ngIf (sempre undefined), quindi la classe andava su TUTTI i bottoni -->
      @if (actionButtons?.length) {
        <div
          class="flex-0 margin-bottom flex align-center full-width">
          @for (button of actionButtons; track button) {
            <button
              [class]="'flex-1 btn btn-' + (!button.type ? '' : (buttonTypeEnum[button.type] + '-')) + colorTypeEnum[button.color]"
              [ngClass]="{'margin-left-small': true}"
              (click)="onClickButton(button)">
              <span [data-feather]="button.icon"></span>
              <span>{{button.text | translate}}</span>
            </button>
          }
        </div>
      }
    </div>
  </core-sidebar>
}
